import { EnRptType } from '../enum/en-rpt-type.enum';

export interface IUrl {
  title: string;
  url: string;
  enRptType?: EnRptType;
}
